"use client";

import { c as _c } from "react/compiler-runtime";
import { ContentCard } from "fansunited-sports-ui";
import { LinkPagination } from "@/components/ui/LinkPagination";
import React, { useState, useCallback, useTransition } from "react";
import { usePathname } from "next/navigation";
import { AdSlot } from "@/features/ads/AdSlot";
import { getPostImageUrl } from "@/components/ui/PostImage";
import { formatRelativeTime } from "@/utilities/formatting/date";
import type { Post } from "@/payload-types";
import type { PostLike } from "@/lib/navigation/createUrlBuilder";
const CARD_STYLES = {
  typography: {
    title: "text-lg font-semibold"
  }
} as const;
export interface CompetitionPostsPageClientProps {
  initialPosts: Post[];
  totalPages: number;
  initialPage: number;
  postsPerPage: number;
  heading: string;
  emptyMessage: string;
  buildLink: (post: PostLike) => string;
  fetchPage: (page: number) => Promise<{
    docs: Post[];
  }>;
}
export const CompetitionPostsPageClient: React.FC<CompetitionPostsPageClientProps> = t0 => {
  const $ = _c(35);
  const {
    initialPosts,
    totalPages,
    initialPage,
    heading,
    emptyMessage,
    buildLink,
    fetchPage
  } = t0;
  const [posts, setPosts] = useState(initialPosts);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [isPending, startTransition] = useTransition();
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = page => page > 1 ? `${pathname}?page=${page}` : pathname;
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getPageHref = t1;
  let t2;
  if ($[2] !== currentPage || $[3] !== fetchPage || $[4] !== getPageHref || $[5] !== totalPages) {
    t2 = page_0 => {
      if (page_0 === currentPage || page_0 < 1 || page_0 > totalPages) {
        return;
      }
      startTransition(async () => {
        const result = await fetchPage(page_0);
        setPosts(result.docs);
        setCurrentPage(page_0);
        window.history.replaceState(window.history.state, "", getPageHref(page_0));
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });
    };
    $[2] = currentPage;
    $[3] = fetchPage;
    $[4] = getPageHref;
    $[5] = totalPages;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handlePageChange = t2;
  if (posts.length === 0) {
    let t3;
    if ($[7] !== heading) {
      t3 = <h2 className="text-2xl font-bold">{heading}</h2>;
      $[7] = heading;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== emptyMessage) {
      t4 = <div className="text-center py-12 text-muted-foreground"><p>{emptyMessage}</p></div>;
      $[9] = emptyMessage;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== t3 || $[12] !== t4) {
      t5 = <div className="max-w-350 mx-auto px-4 py-6"><div className="space-y-6">{t3}{t4}</div></div>;
      $[11] = t3;
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  let t3;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AdSlot id="content-top" />;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== heading) {
    t4 = <h2 className="text-2xl font-bold">{heading}</h2>;
    $[15] = heading;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const t5 = `grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${isPending ? "opacity-50" : ""}`;
  let t6;
  if ($[17] !== buildLink || $[18] !== posts) {
    let t7;
    if ($[20] !== buildLink) {
      t7 = post => <ContentCard key={post.id} content={{
        id: String(post.id),
        type: "article",
        link: buildLink(post),
        title: post.title,
        description: post.summary || undefined,
        image: {
          url: getPostImageUrl(post, "medium"),
          alt: post.title
        },
        metadata: {
          time: formatRelativeTime(post.publishedAt)
        }
      }} variant="standard" styles={CARD_STYLES} />;
      $[20] = buildLink;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    t6 = posts.map(t7);
    $[17] = buildLink;
    $[18] = posts;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[22] !== t5 || $[23] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== currentPage || $[26] !== getPageHref || $[27] !== handlePageChange || $[28] !== totalPages) {
    t8 = totalPages > 1 && <div className="mt-8 flex justify-center"><LinkPagination currentPage={currentPage} totalPages={totalPages} getPageHref={getPageHref} onNavigate={handlePageChange} /></div>;
    $[25] = currentPage;
    $[26] = getPageHref;
    $[27] = handlePageChange;
    $[28] = totalPages;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <AdSlot id="content-bottom" />;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t4 || $[32] !== t7 || $[33] !== t8) {
    t10 = <div className="max-w-350 mx-auto px-4 py-6"><div className="space-y-6">{t3}{t4}{t7}{t8}{t9}</div></div>;
    $[31] = t4;
    $[32] = t7;
    $[33] = t8;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
};